import {h} from 'preact';
import cx from 'classnames';
import {LOGIN_URL} from '@util/URLUtils';
import Icon from '../../common/Icon';
import Button from '../../common/Button';

const i18nText = upi.i18n.getTextFromKey;
const lblThankYou = i18nText( 'lbl-thankYou' );
const lblHelpful = i18nText( 'lbl-helpful' );
const lblYouFoundThisHelpful = i18nText( 'lbl-youFoundHelpful' );
const lblYouAndOthersFoundThisHelpful = i18nText( 'lbl-youAndOthersFoundHelpful',
    'You and %COUNT% others found this helpful' );

const VoteUpButton = ( {
                           id,
                           reviewId,
                           votes,
                           hasVoted,
                           className,
                           updateReviewVotes,
                           getRedirectURL
                       }, context ) => {

    const buttonClasses = cx( 'button secondary', className, {'success': hasVoted} );
    const buttonText = hasVoted ? lblThankYou : lblHelpful;
    const votesIndicator = votes > 0 && !hasVoted || votes > 0 && hasVoted ? votes : null;
    const {result, mutation} = updateReviewVotes;

    if ( hasVoted ) {
        return (
            <div data-testid="hasVoted" className="flex items-center font-bold">
                <Icon.ui name="check-circle" className="mr-1 text-lg success"/>
                <span>
                    {votesIndicator > 3
                        ? lblYouAndOthersFoundThisHelpful.replace( '%COUNT%', votesIndicator - 1 )
                        : lblYouFoundThisHelpful
                    }
                </span>
            </div>
        );
    }

    if ( !context.user.isLogged ) {
        return (
            <Button as="a"
                    href={`${LOGIN_URL}?redirect=${getRedirectURL()}`}
                    fillMobile
                    data-testid="redirect"
                    className={buttonClasses}>
                <span className="mx-2">{buttonText}</span> {votesIndicator}
            </Button>
        );
    }

    const handleVoteUp = () => {
        if ( !hasVoted && !result.loading ) {
            mutation( {variables: {input: {reviewId}}} )
        }
    };

    return (
        <Button onClick={handleVoteUp}
                fillMobile
                loading={result.loading}
                data-testid="voteUp"
                className={buttonClasses}>
            <span className="mx-2">{buttonText}</span> {votesIndicator}
        </Button>
    )
};

export default VoteUpButton;